"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _server = _interopRequireDefault(require("react-dom/server"));
var _cccisdPaginator = _interopRequireDefault(require("cccisd-paginator"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _forIn2 = _interopRequireDefault(require("lodash/forIn"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _escapeRegExp2 = _interopRequireDefault(require("lodash/escapeRegExp"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _slice2 = _interopRequireDefault(require("lodash/slice"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _memoize2 = _interopRequireDefault(require("lodash/memoize"));
var _cccisdSpinner = _interopRequireDefault(require("cccisd-spinner"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _md = _interopRequireDefault(require("md5"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _actions = _interopRequireDefault(require("./actions.js"));
var _filter3 = _interopRequireDefault(require("./filter.js"));
var _filterSelected = _interopRequireDefault(require("./filterSelected.js"));
var _disabledMessage = _interopRequireDefault(require("./disabledMessage.js"));
var _listTemplate = _interopRequireDefault(require("./listTemplate.js"));
var _store = _interopRequireDefault(require("store"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _table = _interopRequireDefault(require("./table.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** cccisd-table provides you with a table React component. It can be sortable and filterable. You can download data as an CSV file. */
var Table = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Table, _React$Component);
  function Table(_props, context) {
    var _this;
    _classCallCheck(this, Table);
    _this = _callSuper(this, Table, [_props, context]);
    // Component properties
    _defineProperty(_assertThisInitialized(_this), "filteredTotal", 0);
    _defineProperty(_assertThisInitialized(_this), "_isAjaxMode", function () {
      return _this.props.apiUrl !== '';
    });
    _defineProperty(_assertThisInitialized(_this), "_isAjax", function () {
      return _this._isAjaxMode() && _this.props.ajaxLimit !== 0 && _this.props.ajaxLimit <= _this.state.filtered;
    });
    _defineProperty(_assertThisInitialized(_this), "_isAllData", function () {
      return !_this._isAjaxMode() || _this.state.total <= _this.props.ajaxLimit;
    });
    _defineProperty(_assertThisInitialized(_this), "_isTopHeader", function () {
      return (0, _memoize2["default"])(function (columns) {
        return columns.some(function (column) {
          return column.topHeader;
        });
      })(_this.props.columns);
    });
    _defineProperty(_assertThisInitialized(_this), "_getQuery", function () {
      var query = [];
      if (!(0, _isEmpty2["default"])(_this.props.constantFilter) && !(0, _isFunction2["default"])(_this.props.constantFilter)) {
        (0, _forIn2["default"])(_this.props.constantFilter, function (value, key) {
          query.push("*".concat(key, "=").concat(value));
        });
      }

      // Set ajax row number
      query.push('_ajax=' + _this.props.ajaxLimit);

      // Set limit
      query.push('_limit=' + _this.state.perPage);

      // Set offset
      query.push('_offset=' + _this._getStartRowNumber());

      // Set filter
      _this.props.columns.forEach(function (column, index) {
        if (!column.ajax || !(0, _has2["default"])(column, 'filter') || column.filter !== true || !(0, _has2["default"])(_this.state.filters, column.name)) {
          return;
        }
        var filterSettings = column.filterSettings || {
          type: 'text'
        };
        var field = filterSettings.field || column.name;
        if (_typeof(field) === 'object') {
          console.warn("You cannot use field as an array for column \"".concat(column.name, "\""));
          return;
        }
        switch (filterSettings.type) {
          case 'text':
            query.push(field + '-lk=*' + encodeURIComponent(_this.state.filters[column.name]) + '*');
            break;
          case 'equal':
            query.push(field + '=' + encodeURIComponent(_this.state.filters[column.name]));
            break;
          case 'selectbox':
            if ((0, _has2["default"])(filterSettings, 'custom')) {
              console.warn("You cannot use custom function for column \"".concat(column.name, "\""));
            }
            query.push(field + '=' + encodeURIComponent(_this.state.filters[column.name]));
            break;
          case 'date':
            {
              var _this$state$filters$c = _slicedToArray(_this.state.filters[column.name], 2),
                startDate = _this$state$filters$c[0],
                endDate = _this$state$filters$c[1];
              if (startDate) {
                query.push(field + '-min=' + startDate + ' 00:00:00');
              }
              if (endDate) {
                query.push(field + '-max=' + endDate + ' 23:59:59');
              }
              break;
            }
          default:
            console.warn("Unknown filter type \"".concat(filterSettings.type, "\""));
            break;
        }
      });

      // Set order
      var currentColumn = (0, _find2["default"])(_this.props.columns, {
        name: _this.state.orderBy
      });
      if (currentColumn && currentColumn.ajax) {
        var order = _this.state.isAscentOrder ? '' : '-';
        query.push('_sort=' + order + _this.state.orderBy);
      }
      (0, _forEach2["default"])(_this.props.constantQuery, function (value, key) {
        query.push(key + '=' + value);
      });
      return '?' + query.join('&');
    });
    _defineProperty(_assertThisInitialized(_this), "_update", function () {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var hardLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.isHardLoading;
      var $this = _assertThisInitialized(_this);
      $this.setState({
        loading: loading,
        hardLoading: hardLoading
      });
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
          var response;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _cccisdAxios["default"].get(_this.props.apiUrl + _this._getQuery());
              case 2:
                response = _context.sent;
                $this.setState({
                  data: response.data.data,
                  total: response.data.total || response.data.data.length,
                  filtered: response.data.filtered || 0,
                  loading: false,
                  selectedRows: []
                }, function () {
                  resolve();
                });
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    });
    _defineProperty(_assertThisInitialized(_this), "_planUpdate", function () {
      // Don't update if it is not ajax mode
      if (!_this._isAjaxMode()) {
        return;
      }
      if (_this.timeout) {
        clearTimeout(_this.timeout);
      }
      _this.setState({
        loading: true,
        hardLoading: false
      });
      _this.timeout = setTimeout(function () {
        _this._update(true, false);
      }, 500);
    });
    // Return data with applied constantFilter
    _defineProperty(_assertThisInitialized(_this), "_getActualData", function () {
      if (_this._isAjaxMode()) {
        return _this.state.data;
      }
      if ((0, _isEmpty2["default"])(_this.props.constantFilter) && !(0, _isFunction2["default"])(_this.props.constantFilter)) {
        return _this.props.data;
      }
      return (0, _filter2["default"])(_this.props.data, _this.props.constantFilter);
    });
    // Return only selected rows which matches the data
    _defineProperty(_assertThisInitialized(_this), "_getRealSelectedRows", function () {
      var allRows = (0, _map2["default"])(_this._getActualData(), _this.props.rowKey).map(function (id) {
        return id.toString();
      });
      return (0, _intersection2["default"])(_this.state.selectedRows, allRows);
    });
    _defineProperty(_assertThisInitialized(_this), "_gotoPage", function (page) {
      _this.setState({
        currentPage: page
      }, function () {
        if (_this._isAjax()) {
          _this._update();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getHash", function () {
      // Generate unique hash for the page+table
      var str = _this.props.useOnlyNameForHash ? _this.props.name : window.location.hostname + window.location.pathname + (0, _map2["default"])(_this.props.columns, 'name').toString() + _this.props.name;
      return (0, _md["default"])(str).substr(0, 10);
    });
    _defineProperty(_assertThisInitialized(_this), "_saveSettings", function () {
      if (!_this.props.saveState) {
        return;
      }
      var hash = _this._getHash();
      var state = _store["default"].get('cccisd-table');
      var oldSettings = state && state[hash];
      var newSettings = {
        filters: _this.state.filters,
        orderBy: _this.state.orderBy,
        isAscentOrder: _this.state.isAscentOrder,
        perPage: _this.state.perPage
      };
      if (!(0, _isEqual2["default"])(oldSettings, newSettings)) {
        _store["default"].set('cccisd-table', _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, hash, newSettings)));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_getSettings", function () {
      var state = _store["default"].get('cccisd-table');
      var settings = state && state[_this._getHash()];
      if (!settings) {
        settings = {
          filters: {},
          orderBy: _this.props.orderBy,
          isAscentOrder: _this.props.isAscentOrder,
          perPage: _this.props.perPage
        };
      }

      // Use props filter if exists
      if (!(0, _isEmpty2["default"])(_this.props.filter)) {
        settings.filters = _this.props.filter;
      }

      // Check if orderBy is correct
      var column = (0, _find2["default"])(_this.props.columns, {
        name: settings.orderBy,
        sort: true
      });
      if (column === undefined) {
        column = (0, _find2["default"])(_this.props.columns, ['sort', true]);
      }
      settings.orderBy = column === undefined ? '' : column.name;

      // Check if isAscentOrder is boolean
      if (typeof settings.isAscentOrder !== 'boolean') {
        settings.isAscentOrder = true;
      }

      // Check if perPage is in range
      if (_this.props.perPageOptions.indexOf(settings.perPage) === -1) {
        settings.perPage = _this.props.perPage;
      }
      return settings;
    });
    _defineProperty(_assertThisInitialized(_this), "_onPerPageChange", function (event) {
      _this.setState({
        perPage: event.target.value * 1,
        currentPage: 1
      }, function () {
        if (!_this._isAllData()) {
          _this._update();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onFilterChange", function (column, value) {
      var filters = _this.state.filters;
      if (value === '') {
        delete filters[column];
      } else {
        filters[column] = value;
      }
      _this.setState({
        currentPage: 1,
        filters: filters
      }, function () {
        if (!_this._isAllData()) {
          var currentColumn = (0, _find2["default"])(_this.props.columns, ['name', column]);
          if (currentColumn.ajax) {
            _this._planUpdate();
          }
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_removeFilter", function () {
      _this.setState({
        currentPage: 1,
        showOnlySelected: false,
        filters: {}
      }, function () {
        if (!_this._isAllData()) {
          _this._update();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onSelectRow", function (event) {
      var value = event.target.value;
      var selectedRows = _this.state.selectedRows;
      var index = selectedRows.indexOf(value);
      if (index === -1) {
        selectedRows.push(value);
      } else {
        selectedRows.splice(index, 1);
      }
      _this.setState({
        selectedRows: selectedRows
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onSelectAll", function (e) {
      e.preventDefault();
      if (_this._isAjax()) {
        return;
      }
      var selectedRows = _this.state.selectedRows;
      var rows = _this._getFilteredData();
      rows.forEach(function (row) {
        if (selectedRows.indexOf(row[_this.props.rowKey].toString()) === -1) {
          selectedRows.push(row[_this.props.rowKey].toString());
        }
      });
      _this.setState({
        selectedRows: selectedRows
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onSelectReallyAll", function (e) {
      var checked = e.target.checked;
      var selectedRows = [];
      if (checked) {
        selectedRows = _this._getActualData().map(function (row) {
          return row[_this.props.rowKey].toString();
        });
      }
      _this.setState({
        selectAllChecked: checked,
        selectedRows: selectedRows
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onSelectNone", function (e) {
      e.preventDefault();
      if (_this._isAjax()) {
        return;
      }
      var selectedRows = _this.state.selectedRows;
      var rows = _this._getFilteredData();
      rows.forEach(function (row) {
        var index = selectedRows.indexOf(row[_this.props.rowKey].toString());
        if (index !== -1) {
          selectedRows.splice(index, 1);
        }
      });
      _this.setState({
        selectedRows: selectedRows
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_afterAction", function () {
      _this.setState({
        showOnlySelected: false,
        selectedRows: []
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onOrder", function (orderBy, order) {
      var isAscentOrder;
      if ((0, _isString2["default"])(order)) {
        isAscentOrder = order.toLowerCase() === 'asc';
      } else {
        isAscentOrder = _this.state.isAscentOrder;
        // eslint-disable-next-line eqeqeq
        if (_this.state.orderBy == orderBy) {
          isAscentOrder = !isAscentOrder;
        }
      }
      _this.setState({
        currentPage: 1,
        orderBy: orderBy,
        isAscentOrder: isAscentOrder
      }, function () {
        if (_this._isAjax()) {
          _this._update();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_registerFilterFunction", function (func) {
      _this.setState({
        filterFunction: func
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getFilteredData", function () {
      var rows = _this._getActualData();

      // Don't proceed if it is an ajax request
      if (_this._isAjax()) {
        return rows;
      }
      if ((0, _isFunction2["default"])(_this.state.filterFunction)) {
        rows = (0, _filter2["default"])(rows, _this.state.filterFunction);
      }
      if (_this.state.showOnlySelected) {
        rows = (0, _filter2["default"])(rows, function (row) {
          return _this.state.selectedRows.indexOf(row[_this.props.rowKey].toString()) !== -1;
        });
      }

      // Apply the filter
      _this.props.columns.forEach(function (column, index) {
        if (_this._isAjaxMode() && !_this._isAllData() && column.ajax || !(0, _has2["default"])(column, 'filter') || column.filter !== true || !(0, _has2["default"])(_this.state.filters, column.name)) {
          return;
        }
        var filterSettings = column.filterSettings || {
          type: 'text'
        };
        var fields = filterSettings.field || column.name;
        // make fields array
        if (typeof fields === 'string') {
          fields = [fields];
        }
        if ((0, _has2["default"])(filterSettings, 'custom')) {
          rows = (0, _filter2["default"])(rows, function (row) {
            return filterSettings.custom(row, _this.state.filters[column.name]);
          });
        } else {
          switch (filterSettings.type) {
            case 'text':
              {
                rows = (0, _filter2["default"])(rows, function (row) {
                  var result = false;
                  fields.forEach(function (field) {
                    if (_this.state.filters[column.name] === _this.props.emptySymbol) {
                      // Check if the column is empty
                      if (String(row[field]) === '' || row[field] === null) {
                        result = true;
                      }
                    } else if (String(row[field]).match(new RegExp((0, _escapeRegExp2["default"])(_this.state.filters[column.name]), 'i'))) {
                      result = true;
                    }
                  });
                  return result;
                });
                break;
              }
            case 'equal':
              {
                rows = (0, _filter2["default"])(rows, function (row) {
                  var result = false;
                  fields.forEach(function (field) {
                    // eslint-disable-next-line eqeqeq
                    if (row[field] == _this.state.filters[column.name]) {
                      result = true;
                    }
                  });
                  return result;
                });
                break;
              }
            case 'selectbox':
              {
                rows = (0, _filter2["default"])(rows, function (row) {
                  var result = false;
                  fields.forEach(function (field) {
                    // eslint-disable-next-line eqeqeq
                    if (row[field] == _this.state.filters[column.name]) {
                      result = true;
                    }
                  });
                  return result;
                });
                break;
              }
            case 'date':
              {
                var _this$state$filters$c2 = _slicedToArray(_this.state.filters[column.name], 2),
                  startDate = _this$state$filters$c2[0],
                  endDate = _this$state$filters$c2[1];
                if (startDate) {
                  startDate += ' 00:00:00';
                  rows = (0, _filter2["default"])(rows, function (row) {
                    var result = false;
                    fields.forEach(function (field) {
                      if (row[field] >= startDate) {
                        result = true;
                      }
                    });
                    return result;
                  });
                }
                if (endDate) {
                  endDate += ' 23:59:59';
                  rows = (0, _filter2["default"])(rows, function (row) {
                    var result = false;
                    fields.forEach(function (field) {
                      if (row[field] <= endDate) {
                        result = true;
                      }
                    });
                    return result;
                  });
                }
                break;
              }
            default:
              {
                console.warn("There is no \"".concat(filterSettings.type, "\" filter type"));
                break;
              }
          }
        }
      });

      // Order the data
      if (_this.state.orderBy !== '') {
        var column = (0, _find2["default"])(_this.props.columns, ['name', _this.state.orderBy]);

        // Check if the column hasn't been removed
        if (column !== undefined) {
          var sortSettings = column.sortSettings || {};
          if ((0, _isFunction2["default"])(sortSettings.custom)) {
            rows = (0, _sortBy2["default"])(rows, sortSettings.custom);
          } else {
            var orderBy = sortSettings.field || column.name;
            rows = (0, _sortBy2["default"])(rows, orderBy);
          }
          if (!_this.state.isAscentOrder) {
            rows.reverse();
          }
        }
      }
      return rows;
    });
    _defineProperty(_assertThisInitialized(_this), "_toggleShowOnlySelected", function () {
      _this.setState({
        currentPage: 1,
        showOnlySelected: !_this.state.showOnlySelected
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getColumnsForCsv", function () {
      return (0, _filter2["default"])(_this.props.columns, function (column) {
        return !_this.props.csvOmittedColumns.includes(column.name);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_defaultDownloadCsv", function (rows) {
      // For now we just remove quotes inside and wrap it in quotes
      var prepare = function prepare(string) {
        string = string.replace(/(<([^>]+)>)/gi, ''); // strip HTML tags
        return '"' + string.replace(/"/, '') + '"';
      };
      var columns = _this._getColumnsForCsv();

      // Compose csv
      var csv = [];

      // Add column names
      csv.push(columns.map(function (column) {
        var label = /*#__PURE__*/_react["default"].isValidElement(column.label) ? _server["default"].renderToStaticMarkup(column.label) : column.label;
        return prepare(label);
      }).join(','));

      // Add data
      rows.forEach(function (row) {
        var array = columns.map(function (column) {
          var value;
          if ((0, _isFunction2["default"])(column.renderCSV)) {
            value = column.renderCSV(row[column.name], row);
          } else {
            value = (0, _isFunction2["default"])(column.render) ? column.render(row[column.name], row, _this.props.callbacks) : row[column.name];
          }
          if (typeof value === 'undefined') {
            value = '';
          }
          value = /*#__PURE__*/_react["default"].isValidElement(value) ? _server["default"].renderToStaticMarkup(value) : String(value);
          return prepare(value);
        });
        csv.push(array.join(','));
      });
      csv = csv.join('\n');
      var link = _this.refs.downloadLink;
      link.download = _this.props.csvFilename;
      link.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      link.click();
    });
    _defineProperty(_assertThisInitialized(_this), "_downloadCsv", function () {
      var rows = _this._getFilteredData();
      if (_this.props.csvDownloadFunction) {
        _this.props.csvDownloadFunction(rows, _this._getQuery());
      } else {
        _this._defaultDownloadCsv(rows);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_renderButtons", function () {
      var buttons = [];

      // Reload data button
      var reloadDataButton = _this._renderReloadDataButton();
      if (reloadDataButton) {
        buttons.push(reloadDataButton);
      }

      // Per page
      var perPageOptions = _this._renderPerPageOptions();
      if (perPageOptions) {
        buttons.push(perPageOptions);
      }

      // CSV download button
      if (_this.props.isCsvDownload) {
        buttons.push( /*#__PURE__*/_react["default"].createElement("span", {
          className: _table["default"].button,
          key: "csvDownload"
        }, /*#__PURE__*/_react["default"].createElement(_disabledMessage["default"], {
          number: _this.props.ajaxLimit,
          disabled: typeof _this.props.csvDownloadFunction !== 'function' && _this._isAjax()
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-default btn-sm",
          onClick: _this._downloadCsv,
          title: "Download as CSV",
          disabled: typeof _this.props.csvDownloadFunction !== 'function' && _this._isAjax()
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "glyphicon glyphicon-download-alt"
        }), " ", _this.props.csvButtonTitle)), /*#__PURE__*/_react["default"].createElement("a", {
          ref: "downloadLink",
          href: "#",
          style: {
            display: 'none'
          }
        }, "Download CSV")));
      }
      if (buttons.length === 0) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _table["default"].buttons
      }, buttons);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderPerPageOptions", function () {
      if (!_this.props.showPerPageOptions) {
        return null;
      }
      var options = _this.props.perPageOptions.map(function (number) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: number,
          value: number
        }, number);
      });
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _table["default"].button,
        key: "perPage"
      }, "Per page:", ' ', /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-control input-sm",
        style: {
          width: 'auto',
          display: 'inline-block'
        },
        value: _this.state.perPage,
        onChange: _this._onPerPageChange
      }, options));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderReloadDataButton", function () {
      if (!_this._isAjaxMode() || !_this.props.showReloadButton) {
        return null;
      }
      var spinner = _this.state.loading && !_this.state.hardLoading ? /*#__PURE__*/_react["default"].createElement(_cccisdSpinner["default"], null) : null;
      var buttonStyle = _this.state.loading && !_this.state.hardLoading ? {
        visibility: 'hidden'
      } : {};
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _table["default"].button,
        key: "refresh",
        style: {
          position: 'relative',
          display: 'inline-block'
        }
      }, spinner, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-default btn-sm",
        onClick: _this._update.bind(null, true, true),
        title: "Reload data",
        style: buttonStyle
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-repeat"
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "_getTotal", function () {
      return _this._isAjaxMode() ? _this.state.total : _this._getActualData().length;
    });
    _defineProperty(_assertThisInitialized(_this), "_getFilteredTotal", function () {
      return _this._isAjax() ? _this.state.filtered : _this.filteredTotal;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderCount", function (filtered, all) {
      var clearFilter = null;
      if (_this.state.showOnlySelected || !(0, _isEmpty2["default"])(_this.state.filters)) {
        clearFilter = /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-primary btn-xs",
          onClick: _this._removeFilter
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "glyphicon glyphicon-remove"
        }), " Remove Filter");
      }
      var countMsg = _this.props.hideShowingRowsSummary ? '' : "Showing ".concat(filtered, " of ").concat(all, " rows");
      if (!countMsg && !clearFilter) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _table["default"].countBlock
      }, countMsg, " ", clearFilter);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderThead", function () {
      var getColumn = function getColumn(column) {
        var isRowSpan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var className = column["class"] || '';
        var tooltip;
        if (column.tooltip) {
          tooltip = /*#__PURE__*/_react["default"].createElement("span", {
            className: _table["default"].tooltip
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                textAlign: 'left'
              }
            }, column.tooltip)
          }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)));
        }

        // Show sort style
        if (column.sort && (column.ajax || !_this._isAjax())) {
          className += ' ' + _table["default"].sortable;
          // eslint-disable-next-line eqeqeq
          if (column.name == _this.state.orderBy) {
            className += _this.state.isAscentOrder ? ' ' + _table["default"].sortable_asc : ' ' + _table["default"].sortable_desc;
          }
          return /*#__PURE__*/_react["default"].createElement("th", _extends({
            className: className,
            key: column.name,
            onClick: _this._onOrder.bind(null, column.name)
          }, isRowSpan ? {
            rowSpan: 2
          } : {}), column.label, tooltip);
        }
        return /*#__PURE__*/_react["default"].createElement("th", _extends({
          className: className,
          key: column.name
        }, isRowSpan ? {
          rowSpan: 2
        } : {}), column.label, tooltip);
      };
      var isTopHeader = _this._isTopHeader();
      var columns = _this.props.columns;
      if (isTopHeader) {
        var spanCount = 0;
        var colSpan = 0;
        columns.forEach(function (column, index) {
          if (column.topHeader) {
            if (spanCount > 0) {
              columns[index - colSpan + spanCount].colSpan = colSpan - spanCount;
            }
            colSpan = column.topHeaderSpan || 1;
            column.colSpan = colSpan;
            spanCount = colSpan;
          }
          if (spanCount-- < 1) {
            column.isRowSpan = true;
          }
        });
        if (spanCount > 0) {
          columns[columns.length - colSpan + spanCount].colSpan = colSpan - spanCount;
        }
      }
      var firstRow = [];
      var secondRow = [];
      columns.forEach(function (column) {
        if (column.topHeader) {
          firstRow.push( /*#__PURE__*/_react["default"].createElement("th", {
            key: column.name,
            colSpan: column.colSpan,
            className: _table["default"].topHeader
          }, column.topHeader, column.topHeaderTooltip && /*#__PURE__*/_react["default"].createElement("span", {
            className: _table["default"].tooltip
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                textAlign: 'left'
              }
            }, column.topHeaderTooltip)
          }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))));
        }
        if (column.isRowSpan || !isTopHeader) {
          firstRow.push(getColumn(column, column.isRowSpan));
        } else {
          secondRow.push(getColumn(column));
        }
      });

      // Is Number?
      if (_this.props.isRowNumber) {
        firstRow.unshift( /*#__PURE__*/_react["default"].createElement("th", _extends({
          key: "number_column",
          className: _table["default"].numberColumn
        }, secondRow.length > 0 ? {
          rowSpan: 2
        } : {}), "#"));
      }

      // Is Checkbox?
      if (_this._isShowCheckboxes()) {
        if (_this.props.isSimpleCheckboxes) {
          var title = _this.state.selectAllChecked ? 'Uncheck all' : 'Check all';
          firstRow.unshift( /*#__PURE__*/_react["default"].createElement("th", _extends({
            key: "checkbox_column",
            className: _table["default"].checkboxColumn + ' ' + _table["default"].checkboxColumnSimple
          }, secondRow.length > 0 ? {
            rowSpan: 2
          } : {}), /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            title: title,
            type: "checkbox",
            value: "1",
            checked: _this.state.selectAllChecked,
            onChange: _this._onSelectReallyAll,
            disabled: _this._isAjax()
          }))));
        } else {
          firstRow.unshift( /*#__PURE__*/_react["default"].createElement("th", _extends({
            key: "checkbox_column",
            className: _table["default"].checkboxColumn
          }, secondRow.length > 0 ? {
            rowSpan: 2
          } : {}), /*#__PURE__*/_react["default"].createElement("a", {
            href: "#",
            onClick: _this._onSelectAll,
            title: "Check all filtered records"
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "glyphicon glyphicon-check"
          })), ' ', /*#__PURE__*/_react["default"].createElement("a", {
            href: "#",
            onClick: _this._onSelectNone,
            title: "Uncheck all filtered records"
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "glyphicon glyphicon-unchecked"
          }))));
        }
      }
      var result = [/*#__PURE__*/_react["default"].createElement("tr", {
        key: "first"
      }, firstRow)];
      if (secondRow.length > 0) {
        result.push( /*#__PURE__*/_react["default"].createElement("tr", {
          key: "second"
        }, secondRow));
      }
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderTfoot", function () {
      if (!_this.props.footer) {
        return null;
      }
      var foot = _this.props.columns.map(function (column) {
        return /*#__PURE__*/_react["default"].createElement("th", null, _this.props.footer[column.name]);
      });
      if (_this.props.isRowNumber) {
        foot.unshift( /*#__PURE__*/_react["default"].createElement("th", {
          className: _table["default"].numberColumn
        }));
      }
      if (_this._isShowCheckboxes()) {
        foot.unshift( /*#__PURE__*/_react["default"].createElement("th", {
          className: _table["default"].checkboxColumn
        }));
      }
      return /*#__PURE__*/_react["default"].createElement("tfoot", null, /*#__PURE__*/_react["default"].createElement("tr", null, foot));
    });
    _defineProperty(_assertThisInitialized(_this), "_isShowCheckboxes", function () {
      return _this.props.rowActions.length > 0 || (0, _isFunction2["default"])(_this.props.rowSelectedCallback);
    });
    _defineProperty(_assertThisInitialized(_this), "_onRowClick", function (row) {
      _this.props.onRowClick(row);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderFilter", function () {
      // Don't show filter if there is no data
      if (_this._getTotal() === 0) {
        return null;
      }
      if (!(0, _find2["default"])(_this.props.columns, {
        filter: true
      }) && !_this._isShowCheckboxes()) {
        return null;
      }
      var lastColumn = (0, _last2["default"])(_this.props.columns);
      var filters = _this.props.columns.map(function (column) {
        var className = column["class"] || '';
        if ((0, _has2["default"])(column, 'filter') && column.filter === true) {
          var disabled = _this._isAjax() && !column.ajax;
          return /*#__PURE__*/_react["default"].createElement("th", {
            key: column.name,
            className: className
          }, /*#__PURE__*/_react["default"].createElement(_disabledMessage["default"], {
            number: _this.props.ajaxLimit,
            disabled: disabled,
            display: "block",
            placement: column.name === lastColumn.name ? 'bottom-left' : 'bottom'
          }, /*#__PURE__*/_react["default"].createElement(_filter3["default"], {
            column: column.name,
            value: _this.state.filters[column.name],
            onFilterChange: _this._onFilterChange,
            settings: column.filterSettings,
            disabled: disabled
          })));
        }
        return /*#__PURE__*/_react["default"].createElement("th", {
          key: column.name,
          className: className
        });
      });

      // Is Number?
      if (_this.props.isRowNumber) {
        filters.unshift( /*#__PURE__*/_react["default"].createElement("th", {
          key: "number_column"
        }));
      }
      // Is Checkbox?
      if (_this._isShowCheckboxes()) {
        if (_this.props.isSimpleCheckboxes) {
          filters.unshift( /*#__PURE__*/_react["default"].createElement("th", {
            key: "checkbox_column"
          }));
        } else {
          filters.unshift( /*#__PURE__*/_react["default"].createElement("th", {
            key: "checkbox_column"
          }, /*#__PURE__*/_react["default"].createElement(_disabledMessage["default"], {
            number: _this.props.ajaxLimit,
            disabled: _this._isAjax(),
            placement: "right",
            size: null
          }, /*#__PURE__*/_react["default"].createElement(_filterSelected["default"], {
            showSelected: _this.state.showOnlySelected,
            onClick: _this._toggleShowOnlySelected,
            disabled: _this._isAjax()
          }))));
        }
      }
      return /*#__PURE__*/_react["default"].createElement("tr", null, filters);
    });
    _defineProperty(_assertThisInitialized(_this), "_getStartRowNumber", function () {
      return (_this.state.currentPage - 1) * _this.state.perPage;
    });
    _defineProperty(_assertThisInitialized(_this), "_getRowsForPage", function () {
      var rows = _this._getFilteredData();
      _this.filteredTotal = rows.length;

      // Get rows for current page
      var start = _this._getStartRowNumber();
      if (!_this._isAjax()) {
        var end = _this.state.currentPage * _this.state.perPage;
        rows = (0, _slice2["default"])(rows, start, end);
      }
      return rows;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderTbody", function () {
      var rows = _this._getRowsForPage();
      var start = _this._getStartRowNumber();

      // Render column values
      rows = rows.map(function (item, index) {
        var key = item[_this.props.rowKey].toString();
        var row = _this.props.columns.map(function (column) {
          var value = (0, _isFunction2["default"])(column.render) ? column.render(item[column.name], item, _this.props.callbacks) : item[column.name];
          var className = column["class"] || '';

          // Add special classes
          if ((0, _isFunction2["default"])(column.setClass)) {
            className += ' ' + column.setClass(item[column.name], item);
          }

          // Add special style
          var tdStyle = {};
          if ((0, _isFunction2["default"])(column.setStyle)) {
            tdStyle = column.setStyle(item[column.name], item);

            // Remove backgroundColor and color for selected rows
            if (_this.state.selectedRows.indexOf(key) !== -1) {
              delete tdStyle.backgroundColor;
              delete tdStyle.color;
            }
          }
          var props = {
            className: className,
            key: column.name,
            style: tdStyle
          };
          if (_this.props.onRowClick) {
            props.onClick = _this._onRowClick.bind(null, item);
          }
          return /*#__PURE__*/_react["default"].createElement("td", props, value);
        });

        // Is Number?
        if (_this.props.isRowNumber) {
          row.unshift( /*#__PURE__*/_react["default"].createElement("td", {
            key: "number_column",
            className: _table["default"].numberColumn
          }, start + index + 1));
        }
        // Is Checkbox?
        if (_this._isShowCheckboxes()) {
          var checked = _this.state.selectedRows.indexOf(key) !== -1;
          var classname = (0, _classnames3["default"])(_table["default"].checkboxColumn, _defineProperty({}, "".concat(_table["default"].checkboxColumnSimple), _this.props.isSimpleCheckboxes));
          row.unshift( /*#__PURE__*/_react["default"].createElement("td", {
            key: "checkbox_column",
            className: classname
          }, /*#__PURE__*/_react["default"].createElement(_disabledMessage["default"], {
            number: _this.props.ajaxLimit,
            disabled: _this._isAjax(),
            placement: "right",
            size: null
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            value: key,
            checked: checked,
            onChange: _this._onSelectRow,
            disabled: _this._isAjax(),
            id: _this.props.name + '_row_' + key
          })))));
        }
        var className = (0, _classnames3["default"])(_defineProperty(_defineProperty({}, _table["default"].selected, _this.state.selectedRows.includes(key)), _table["default"].clickableRow, !_this.state.selectedRows.includes(key) && _this.props.onRowClick && _this.props.showRowClickable), _this.props.setRowClass && _this.props.setRowClass(item));
        return /*#__PURE__*/_react["default"].createElement("tr", {
          key: key,
          className: className
        }, row);
      });
      return rows;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderPaginator", function () {
      var total = Math.ceil(_this._getFilteredTotal() / _this.state.perPage);
      if (total <= 1) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdPaginator["default"], {
        total: total,
        currentPage: _this.state.currentPage,
        onPageChange: _this._gotoPage,
        className: _table["default"].paginator
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getFilters", function () {
      // Don't show filter if there is no data
      if (_this._getTotal() === 0) {
        return {};
      }
      if (!(0, _find2["default"])(_this.props.columns, {
        filter: true
      })) {
        return {};
      }
      var filters = {};
      (0, _forEach2["default"])(_this.props.columns, function (column) {
        if ((0, _has2["default"])(column, 'filter') && column.filter === true) {
          var disabled = _this._isAjax() && !column.ajax;
          filters[column.name] = /*#__PURE__*/_react["default"].createElement("div", {
            key: column.name,
            style: {
              marginBottom: '.5em'
            }
          }, /*#__PURE__*/_react["default"].createElement("label", null, column.label), /*#__PURE__*/_react["default"].createElement(_disabledMessage["default"], {
            number: _this.props.ajaxLimit,
            disabled: disabled,
            display: "block",
            placement: "bottom"
          }, /*#__PURE__*/_react["default"].createElement(_filter3["default"], {
            column: column.name,
            value: _this.state.filters[column.name],
            onFilterChange: _this._onFilterChange,
            settings: column.filterSettings,
            disabled: disabled
          })));
        }
      });
      return filters;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderListFilters", function () {
      var filters = _this._getFilters();
      if ((0, _isEmpty2["default"])(filters)) {
        return null;
      }
      var result = [];
      (0, _forEach2["default"])(_this.props.columns, function (column) {
        if (filters[column.name]) {
          result.push(filters[column.name]);
        }
      });
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderListSorts", function () {
      var options = [];
      (0, _forEach2["default"])(_this.props.columns, function (column) {
        if (column.sort && (column.ajax || !_this._isAjax())) {
          options.push( /*#__PURE__*/_react["default"].createElement("option", {
            key: 'asc_' + column.name,
            value: 'asc_' + column.name
          }, "Sort by ".concat(column.label, " (A-Z)")));
          options.push( /*#__PURE__*/_react["default"].createElement("option", {
            key: 'desc_' + column.name,
            value: 'desc_' + column.name
          }, "Sort by ".concat(column.label, " (Z-A)")));
        }
      });
      if (options.length === 0) {
        return null;
      }
      var onListSortChange = function onListSortChange(event) {
        var _event$target$value$s = event.target.value.split('_'),
          _event$target$value$s2 = _toArray(_event$target$value$s),
          order = _event$target$value$s2[0],
          other = _event$target$value$s2.slice(1);
        _this._onOrder(other.join('_'), order);
      };
      var value = (_this.state.isAscentOrder ? 'asc' : 'desc') + '_' + _this.state.orderBy;
      return /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-control input-sm",
        value: value,
        onChange: onListSortChange
      }, options);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderList", function () {
      if (!(0, _isFunction2["default"])(_this.props.renderAsList)) {
        return null;
      }
      var rows = _this._getRowsForPage();
      var start = _this._getStartRowNumber();

      // Render column values
      return rows.map(function (row, index) {
        var key = row[_this.props.rowKey].toString();
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: key
        }, _this.props.renderAsList(row, start + index + 1));
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_renderAsList", function () {
      var Template = _this.props.listTemplate;
      var templateProps = {
        tableProps: _this.props,
        perPageOptions: _this._renderPerPageOptions(),
        reloadDataButton: _this._renderReloadDataButton(),
        count: _this._renderCount(_this._getFilteredTotal(), _this._getTotal()),
        list: _this._renderList(),
        paginator: _this._renderPaginator(),
        filterBlock: _this._renderListFilters(),
        filters: _this._getFilters(),
        sortBlock: _this._renderListSorts(),
        rows: _this._getRowsForPage(),
        startNumber: _this._getStartRowNumber() + 1,
        registerFilterFunction: _this._registerFilterFunction
      };
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: _this.state.loading && _this.state.hardLoading
      }, /*#__PURE__*/_react["default"].createElement(Template, templateProps));
    });
    var _settings = _this._getSettings();
    _this.state = {
      data: [],
      total: 0,
      filtered: 0,
      loading: false,
      hardLoading: true,
      currentPage: 1,
      perPage: _settings.perPage,
      selectedRows: (0, _cloneDeep2["default"])(_props.selectedRows),
      selectAllChecked: false,
      filters: _settings.filters,
      orderBy: _settings.orderBy,
      isAscentOrder: _settings.isAscentOrder,
      showOnlySelected: false,
      filterFunction: null
    };
    return _this;
  }
  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.didMount();
      if ((0, _isFunction2["default"])(this.props.rowSelectedCallback)) {
        this.props.rowSelectedCallback(this._getRealSelectedRows());
      }
      if (this._isAjaxMode()) {
        this._update();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // Show warning message
      if (this.props.apiUrl !== '' && this.props.data.length > 0) {
        console.warn('You cannot pass "apiUrl" and "data" props together. "data" will be ignored.');
      }
      this._saveSettings();
      if ((0, _isFunction2["default"])(this.props.rowSelectedCallback)) {
        this.props.rowSelectedCallback(this._getRealSelectedRows());
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.renderAsList) {
        return this._renderAsList();
      }
      var thead = this._renderThead();
      var filter = this._renderFilter();
      var tbody = this._renderTbody();
      var buttons = this._renderButtons();
      var count = this._renderCount(this._getFilteredTotal(), this._getTotal());

      // Calculate the number of columns
      var colSpan = this.props.columns.length;
      if (this.props.isRowNumber) {
        colSpan++;
      }
      if (this._isShowCheckboxes()) {
        colSpan++;
      }
      // Compose the message when there is no filtered data
      var noDataMessage = this.filteredTotal === 0 ? /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        colSpan: colSpan
      }, this.props.noRecordsMessage)) : null;
      var bottomPaginator = null;
      var paginator = this._renderPaginator();
      if (paginator && this.props.showBottomPaginator) {
        bottomPaginator = /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames3["default"])('clearfix', _table["default"].bottomBar)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "pull-right"
        }, paginator));
      }
      var showTopBar = buttons || count || paginator;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _table["default"].tableWrapper + ' ' + this.props.wrapperClassName
      }, this.props.showRowActions && /*#__PURE__*/_react["default"].createElement(_actions["default"], {
        wrapperClassName: _table["default"].marginBottom,
        actions: this.props.rowActions,
        selectedRows: this.state.selectedRows,
        afterAction: this._afterAction,
        callbacks: this.props.callbacks,
        disabled: this._isAjax(),
        disabledNumber: this.props.ajaxLimit
      }), showTopBar && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames3["default"])('clearfix', _table["default"].topBar)
      }, buttons, count, /*#__PURE__*/_react["default"].createElement("div", {
        className: "pull-right"
      }, paginator)), /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading && this.state.hardLoading
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _table["default"].tableScroll
      }, /*#__PURE__*/_react["default"].createElement("table", {
        className: this.props.className + ' ' + _table["default"].table
      }, /*#__PURE__*/_react["default"].createElement("thead", null, thead, filter), /*#__PURE__*/_react["default"].createElement("tbody", null, tbody, noDataMessage), this._renderTfoot()))), bottomPaginator);
    }
  }]);
  return Table;
}(_react["default"].Component);
_defineProperty(Table, "propTypes", {
  /** The name for the table. It's used when saving the table state. <i>e.g.</i> sortable columns, filters, etc... If there is only one table on the page it's not necessary to assign a name. */
  name: _propTypes["default"].string,
  /** The class name of the wrapper div that contains the table. */
  wrapperClassName: _propTypes["default"].string,
  /** The class name of the table. */
  className: _propTypes["default"].string,
  /** An array with colums. For example:
  <pre>[
  {name: 'id', label: 'ID'},
  {name: 'name', label: 'Name', sort: true, filter: true},
  {name: 'email', label: 'Email', sort: true, filter: true},
  ]</pre> */
  columns: _propTypes["default"].array,
  /** An array of data. For example:
  <pre>[
  {id: 1, name: 'Mike', email: 'mike@gmail.com'},
  {id: 2, name: 'Helen', email: 'helen@gmail.com'},
  {id: 3, name: 'Bob', email: 'bob@gmail.com'},
  ]</pre> */
  data: _propTypes["default"].array,
  /** URL for API <br> Note: You cannot use "apiUrl" and "data" simultaneously; "data" will be ignored.
   */
  apiUrl: _propTypes["default"].string,
  /** A key with a unique value, from "data" above.  This key must exist. */
  rowKey: _propTypes["default"].string,
  /** Show row number or not? */
  isRowNumber: _propTypes["default"].bool,
  /** An array of objects containing JS functions that can be applied to selected rows. <br> <i>E.g.</i> `{name: 'Do something', action: function(selectedRows) {}}` */

  /** An array of functions which can be applied for checked rows. For example:
  <pre>[
  {text: 'Do something', action: function() {}},
  {text: 'Do another thing', action: function() {}},
  ]</pre> */
  rowActions: _propTypes["default"].array,
  /** Show row actions selectbox or not? */
  showRowActions: _propTypes["default"].bool,
  /** An array of rows that will be selected by default */
  selectedRows: _propTypes["default"].array,
  /** A function that will be called afterr changing selected rows */
  rowSelectedCallback: _propTypes["default"].func,
  /** A function that will be called after the table component mounts */
  didMount: _propTypes["default"].func,
  /** Column name that is used for default sorting, if left blank, the first sortable column will be used.  */
  orderBy: _propTypes["default"].string,
  /** Use ascending order or not? */
  isAscentOrder: _propTypes["default"].bool,
  /** Number of rows per page */
  perPage: _propTypes["default"].number,
  /** Show options to change number of rows per page? */
  showPerPageOptions: _propTypes["default"].bool,
  /** Sets the available options for how many rows per page. */
  perPageOptions: _propTypes["default"].array,
  /** Hide "Showing x of y rows" at top of table? */
  hideShowingRowsSummary: _propTypes["default"].bool,
  /** When in AJAX mode, the number of rows that will be returned from an AJAX request. <br> If "0" AJAX will not be used.
   */
  ajaxLimit: _propTypes["default"].number,
  /** When in AJAX mode, this will prevent the page from changing while loading data from an AJAX request */
  isHardLoading: _propTypes["default"].bool,
  /** The regular filter <i>e.g.</i>: <br/>
   <pre>{name: "Bob", email: "@gmail.com"}</pre> */
  filter: _propTypes["default"].object,
  /** A filter that will be applied to the table permanently. <i>e.g.</i>:
  <pre>{isActive: 1}</pre>
  */
  constantFilter: _propTypes["default"].object,
  /** A query that will be appended to all apiURL requests <i>e.g.</i>:
  <pre>{codebook_id: 1}</pre>
  */
  constantQuery: _propTypes["default"].object,
  /** This symbol will mean nothing when put in a filter. */
  emptySymbol: _propTypes["default"].string,
  /** Display a paginator below the table or not? */
  showBottomPaginator: _propTypes["default"].bool,
  /** Show the reload button or not? */
  showReloadButton: _propTypes["default"].bool,
  /** Save the table's state, sort and filter params, in local storage? */
  saveState: _propTypes["default"].bool,
  /** Display the CSV download button or not? */
  isCsvDownload: _propTypes["default"].bool,
  /** Sets the title for the CSV download button. */
  csvButtonTitle: _propTypes["default"].string,
  /** Sets the name of the CSV file to be downloaded */
  csvFilename: _propTypes["default"].string,
  /** Customizable download function */
  csvDownloadFunction: _propTypes["default"].func,
  /** An array of column names, that will be omitted in the CSV file */
  csvOmittedColumns: _propTypes["default"].array,
  /** Display a single, simple checkbox that allows a user to select all or none of the table. */
  isSimpleCheckboxes: _propTypes["default"].bool,
  /** An object with callback functions that can be called when rendering columns and in rowActions. */
  callbacks: _propTypes["default"].object,
  /** The message shown when there are no records. */
  noRecordsMessage: _propTypes["default"].string,
  /** A function that renders the table as a list when called. */
  renderAsList: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
  /** Template component that shows the list. */
  listTemplate: _propTypes["default"].func,
  /** A click event handler for a whole row that accepts row objects */
  onRowClick: _propTypes["default"].func,
  /** If true, and onRowClick is a function, then each row will have a clickable style. */
  showRowClickable: _propTypes["default"].bool,
  /** If this is a function then it will set a className for every row when called. The row can be passed into the function.  */
  setRowClass: _propTypes["default"].func,
  /** Generates a hash based solely on the table name. */
  useOnlyNameForHash: _propTypes["default"].bool,
  /** Information to display in a fixed table footer <i>e.g.</i>:
  <pre>{colNameA: valueA, colNameB: valueB}</pre> */
  footer: _propTypes["default"].object
});
_defineProperty(Table, "defaultProps", {
  name: '',
  wrapperClassName: '',
  className: 'table table-condensed table-striped table-bordered',
  columns: [],
  data: [],
  apiUrl: '',
  rowKey: 'id',
  isRowNumber: false,
  rowActions: [],
  showRowActions: true,
  selectedRows: [],
  rowSelectedCallback: null,
  didMount: function didMount() {},
  orderBy: '',
  isAscentOrder: true,
  perPage: 50,
  showPerPageOptions: true,
  perPageOptions: [10, 25, 50, 100, 200],
  hideShowingRowsSummary: false,
  ajaxLimit: 1000,
  isHardLoading: true,
  filter: {},
  constantFilter: {},
  constantQuery: {},
  emptySymbol: '*',
  showBottomPaginator: true,
  showReloadButton: true,
  saveState: true,
  isCsvDownload: false,
  csvButtonTitle: 'CSV',
  csvFilename: 'download.csv',
  csvDownloadFunction: null,
  csvOmittedColumns: [],
  isSimpleCheckboxes: false,
  callbacks: {},
  noRecordsMessage: 'No matching records found',
  renderAsList: null,
  listTemplate: _listTemplate["default"],
  onRowClick: null,
  showRowClickable: true,
  setRowClass: null,
  useOnlyNameForHash: false,
  footer: null
});